import DynamicEntityDetails from './DynamicEntityDetails';
import DynamicEntityDetailsNavigation from './DynamicEntityDetailsNavigation';

export default DynamicEntityDetails;
export {
  DynamicEntityDetailsNavigation
};
